import useCountries from '@/lib/hooks/fetchers/useCountries';
import { Country } from '@/lib/types/bevmaq.types';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import { Errors } from './Errors';

type Props = {
  name?: string;
  error: any;
  register: any;
  options?: any[];
  control: any;
  isMulti?: boolean;
  containerClasses?: string;
  label?: string;
};

const CountrySelector = (props: Props) => {
  const { t } = useTranslation();
  const { countries: countriesOptions } = useCountries();
  const customStyles = {
    input: (provided: any) => ({
      ...provided,
      'input:focus': {
        boxShadow: 'none',
      },
    }),
    control: (provider: any) => ({
      ...provider,
      borderColor: props.error?.message !== undefined ? 'red' : '#6b7280',
      borderRadius: '0px',
      'control:focus': {
        borderColor: '#6b7280',
      },
    }),
  };
  const options = props.options ?? countriesOptions;

  const name = props.name ?? 'country';

  return (
    <div className={props.containerClasses}>
      <label className='input-label' htmlFor={name}>
        {props.label ?? t('common:Country')} *
      </label>

      <Controller
        name={name}
        control={props.control}
        render={({ field: { value, onChange, onBlur } }) => {
          return (
            <Select
              placeholder=''
              options={options}
              styles={customStyles}
              {...props.register(name, {
                required: t('Required'),
              })}
              getOptionLabel={(c: Country) => c.name}
              getOptionValue={(c: Country) => c.alpha2}
              onBlur={onBlur}
              onChange={(options: Country) => onChange(options.alpha2)}
              isMulti={props.isMulti}
              value={options.filter((option) => value?.includes(option.alpha2))}
              id={name}
            />
          );
        }}
      />

      <Errors data={props.error} />
    </div>
  );
};

export default CountrySelector;
